
import InfoPageLayout from "./InfoPageLayout";
import ClipboardButton from "./ClipboardButton"; // <-- Import the new component
import { Sparkles } from "lucide-react";

const Careers = () => {
  return (
    <InfoPageLayout
      title="Careers at Xenford"
      subtitle="Join our mission to build software that simplifies complexity and empowers users."
    >
      <div className="flex flex-col items-center text-center py-16 px-6 bg-gray-900/50 border border-dashed border-white/20 rounded-2xl">
        <Sparkles size={48} className="text-purple-400 mb-6" />
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
          The Right Role Isn't Here... Yet.
        </h3>
        <p className="text-gray-400 max-w-xl mb-8">
          We are not actively hiring for specific positions right now, but we
          are always searching for passionate problem-solvers, brilliant
          engineers, and thoughtful designers who believe in our mission.
        </p>

        {/* ✅ Replace the <a> tag with the new component */}
        <ClipboardButton
          email="careers@xenford.com"
          buttonText="Introduce Yourself"
        />
      </div>
    </InfoPageLayout>
  );
};

export default Careers;
